module.exports = __webpack_public_path__ + "img/coor1.57136de3.png";